import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import DefaultInfoCard from "reusables/Cards/InfoCards/DefaultInfoCard";
import SectionLayout from "reusables/layouts/SectionLayout";

const sectors = [
  {
    icon: "domain",
    title: "Offices & Workplaces",
    description:
      "From small offices to large corporate campuses — we supply hygiene products, cleaning chemicals, and washroom consumables to keep your workplace running.",
  },
  {
    icon: "school",
    title: "Schools & Educational Facilities",
    description:
      "Safe, effective cleaning and hygiene supplies for educational environments — with Garda-checked delivery staff and products suitable for use around children.",
  },
  {
    icon: "local_hospital",
    title: "Healthcare & Care Homes",
    description:
      "Clinical-grade disinfectants, PPE, clinical waste bags, and infection control products for GP practices, clinics, dental offices, and residential care facilities.",
  },
  {
    icon: "hotel",
    title: "Hospitality & Accommodation",
    description:
      "High-turnover properties need reliable supply chains. We deliver housekeeping chemicals, disposables, and washroom essentials on a schedule that matches your occupancy.",
  },
  {
    icon: "storefront",
    title: "Retail & Commercial Premises",
    description:
      "Keep customer-facing spaces clean and presentable. We supply floor care chemicals, hygiene stations, and janitorial equipment for retail floors and commercial buildings.",
  },
  {
    icon: "construction",
    title: "Facilities & Maintenance Teams",
    description:
      "Janitorial equipment, PPE, and consumables for in-house facilities teams managing multi-site estates, industrial units, or mixed-use developments.",
  },
];

function WhoWeSupply() {
  return (
    <SectionLayout
      mt={20}
      title="Who we supply"
      description="Any business that needs a reliable, professional supply of facilities and hygiene products."
      contents={
        <MKBox mt={4}>
          <Container>
            <Grid container spacing={3}>
              {sectors.map(({ icon, title, description }) => (
                <Grid key={title} item xs={12} md={6}>
                  <DefaultInfoCard icon={icon} title={title} description={description} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </MKBox>
      }
    />
  );
}

export default WhoWeSupply;
